import apiAiAgent from "./axios.ai-agent";
import {
  APIAgentEvent,
  APIGetUserSessionsResponse,
  APISendMessageRequest,
  APISendMessageResponse,
} from "./api.types";

export const APIGetUserSessions = async (userId: string) => {
  const { data } = await apiAiAgent.get<APIGetUserSessionsResponse>(
    `discovery-agent/user/${userId}/sessions`
  );
  return data;
};

export const APIGetConversation = async (conversationId: string) => {
  const { data } = await apiAiAgent.get<APIAgentEvent[]>(
    `discovery-agent/session/${conversationId}/events`
  );
  return data;
};

export const APISendMessage = async (payload: APISendMessageRequest) => {
  const { data } = await apiAiAgent.post<APISendMessageResponse>(`discovery-agent/chat`, payload);
  return data;
};

export const APIGetGroupTerminationUserSessions = async (userId: string) => {
  const { data } = await apiAiAgent.get<APIGetUserSessionsResponse>(
    `group-termination-agent/user/${userId}/sessions`
  );
  return data;
};

export const APIGetGroupTerminationConversation = async (conversationId: string) => {
  const { data } = await apiAiAgent.get<APIAgentEvent[]>(
    `group-termination-agent/session/${conversationId}/events`
  );
  return data;
};

export const APISendGroupTerminationMessage = async (payload: APISendMessageRequest) => {
  const { data } = await apiAiAgent.post<APISendMessageResponse>(
    `group-termination-agent/chat`,
    payload
  );
  return data;
};
